import { render } from "./CustomerNote.vue?vue&type=template&id=1d244980&scoped=true"
import script from "./CustomerNote.vue?vue&type=script&lang=js"
export * from "./CustomerNote.vue?vue&type=script&lang=js"

import "./CustomerNote.vue?vue&type=style&index=0&id=1d244980&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d244980"]])

export default __exports__